import { render, staticRenderFns } from "./BuildingPreference.vue?vue&type=template&id=6a0964a5&scoped=true&"
import script from "./BuildingPreference.vue?vue&type=script&lang=js&"
export * from "./BuildingPreference.vue?vue&type=script&lang=js&"
import style0 from "./BuildingPreference.vue?vue&type=style&index=0&id=6a0964a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0964a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardSubtitle,VCheckbox,VCol,VContainer,VIcon,VRow,VSelect,VTextField})
